import React, { useEffect, useState } from "react";
import { Page, LoadingMsg, EditPageContainer, withServerErrors } from "components/common";
import { Row, Col, Button } from "reactstrap";
import { FormGroup } from "components/common/Forms";
import { Trans, useTranslation } from "react-i18next";
import { NotificationManager } from "react-notifications";
import { LocalForm, Control } from "react-redux-form";
import { ApiClient } from "services";
import BackButton from "components/refactoring/BackButton";
import withReload from "components/common/withReload";
import { compose, withState } from "recompose";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

  const colStyle = {
    xs: false,
    md: 12,
    className: "pt-1 pb-1"
  }

  const headerStyle = {
    style:{fontSize: '1.4em'},
    className: "text-center"
  }

  const lightGrey = {
    style:{backgroundColor: "#fefefe", color: "#333"},
    className:"mb-4 alert alert-secondary pr-5 pt-3 mt-2",
    role:"alert"}
  

  const selectField = {
    style:{border: '1px solid #e1e1e1'}
  }

export const RegisterApp = ({dataPresent = false, item, match, reload}) => {

const client = ApiClient()
const history = useHistory();
const {t} = useTranslation()  

const [isSending, setIsSending] = useState(false);
const [types, setTypes] = useState();
const [loading, setLoading] = useState(false);

const fetchData = async () => {
    setLoading(true)
    try {
      const response = await client.get("connections/apps_types");
      const data = response.data;
      setTypes(data);
      setLoading(false)
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false)
    }
  };
  
  useEffect(() => {
    fetchData();
  }, []);


  function isNumericString(input) {  
    return typeof input === 'string' && !isNaN(input)
  }
  
const handleSave = (values) => {
    setIsSending(true)

    let endpoint = isNumericString(match.params.id)? `/${match.params.id}`:''
    let method = isNumericString(match.params.id)? "put":"post"
    console.log(method)
    client[method](`/portal${endpoint}`, values)
      .then(response => {
        if (method === 'post') {
          console.log("Server response:", response.data);
          NotificationManager.success(t('Application Added Successfully.'));
          setIsSending(false);
          setTimeout(() => {
            history.push("/auth/apps");
          }, 1500);
        } else {
          NotificationManager.success(t('Application Updated Successfully.'));
          setIsSending(false);
          setTimeout(() => {
            reload();
          }, 1500);
        }
        return true;
      })
      .catch(error => {
        console.error("Error:", error);
        if (error.response && error.response.data) {
          const errors = error.response.data;
          Object.entries(errors).forEach(([key, value]) => {
            const errorMessage = `${key.charAt(0).toUpperCase() + key.slice(1)} - ${value}`;
            NotificationManager.error(errorMessage);
          });
        } else {
          NotificationManager.error(t("An error occurred while saving"));
        }
        setIsSending(false);
      });
  };

const authOptions = [
  { value: 'authorization-code', label: t('Authorization Code') },
  { value: 'implicit', label: t('Implicit') },
  { value: 'password', label: t('Resource owner password-based') },
  { value: 'client-credentials', label: t('Client credentials') },
  { value: 'openid-hybrid', label: t('OpenID connect hybrid') },
];
  
const clientOptions = [
  { value: 'confidential', label: t('Confidential') },
  { value: 'public', label: t('Public') },
];

  return (
    <Page title={t("Register Application")}>
      <BackButton />
      <div className="d-flex justify-content-center align-items-center">
      {loading ? (
        <LoadingMsg />
      ) : (
      <>
       <div style={{maxWidth:"70%"}}>
        <div className="text-center"><span {...headerStyle}>Register A New Application</span></div>
        <div {...lightGrey}>
        <ul>
         <li>
          <LocalForm initialState={item} onSubmit={values => handleSave(values)}>
          {!dataPresent && 
          <div>
          <Row>
            <Col {...colStyle}>
              <FormGroup label={t("Name")} model=".name">
                <Control.text model=".name" />
              </FormGroup>
            </Col>
            <Col {...colStyle}>
              <FormGroup label={t("Client Secret")} model=".client_secret">
                <Control.text model=".client_secret"/>
              </FormGroup>
            </Col>
            <Col {...colStyle}>
              <FormGroup label={t("Client Type*")} model=".client_type">
                <Control.select model=".client_type" {...selectField}>
                  {clientOptions.map((i) => (
                    <option key={i.value} value={i.value}>
                      {i.label}
                    </option>
                  ))}
                </Control.select>
              </FormGroup>
            </Col>
            <Col {...colStyle}>
              <FormGroup label={t("Authorization Grant Type*")} model=".authorization_grant_type">
                <Control.select model=".authorization_grant_type" defaultValue={authOptions?.[0].value} {...selectField}>
                  {authOptions.map((i) => (
                    <option key={i.value} value={i.value}>
                      {i.label}
                    </option>
                  ))}
                </Control.select>
              </FormGroup>
            </Col>
            <Col {...colStyle}>
              <FormGroup label={t("Client login URL*")} model=".login" placeholder={t('https://client-app/authenticate')}>
                <Control.text model=".login_url"/>
              </FormGroup>
            </Col>
            <Col {...colStyle}>
              <FormGroup label={t("Type*")} model=".type">
                <Control.select model=".type" {...selectField}>
                  {types?.map((i) => (
                    <option key={i.value} value={i.value}>
                      {i.label}
                    </option>
                  ))}
                </Control.select>
              </FormGroup>
            </Col>
            <Col {...colStyle}>
              <FormGroup label={t("Redirect URLS")} model=".redirect_uris">
                <Control.textarea row="5" model=".redirect_uris" style={{backgroundColor: "#F4F7FE", border: '1px solid #e1e1e1'}} placeholder={t('valid URLs separated by space')}/>
              </FormGroup>
            </Col>
            <Col {...colStyle}>
              <div className="d-flex align-items-center py-1">
                <Control.checkbox hidden model=".skip_authorization" className="mr-2" defaultValue={true}/>
              </div>
            </Col>
          </Row>
          </div>
          }
          <div className="tw-flex my-4">
          {!isSending ? (
            <Button className="mx-0 w-100"><Trans>Save</Trans></Button>
            ):(
            <Button className="mx-0 w-100" disabled><span className="fa fa-spinner fa-spin"/> <Trans>Saving</Trans></Button>
          )}
          </div>
        </LocalForm>
       </li>
      </ul>
      </div>
    </div>
    </>
    )}
    </div>
    </Page>
  );
};

const enhance = compose(
  withReload(),
  withServerErrors(),

  EditPageContainer({
    url: "portal",
    defaultItem: () => ({}),
  }),

  withState("serverErrors", "setServerErrors", {})
);

export default enhance(RegisterApp);